// @flow
import Dialog from 'material-ui/Dialog';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import Campaign from 'common/modules/campaign/domain/Campaign';
import CampaignMetrics from 'common/modules/campaign/domain/CampaignMetrics';
import CampaignAPI from '../services/CampaignAPI';
import PrintCampaignButton from '../printing/PrintCampaignButton';

export const NOTIFY_ADVERTISER_CHECKBOX_ID = 'complete-campaign-dialog-notify-advertiser-checkbox';

const Text = styled.p`
  color: ${({ theme }) => theme.colors.secondaryText};
`;

type Props = {
  onSuccess: (campaign: Campaign) => void;
  onClose: () => void;
  visible: boolean;
  campaign: Campaign;
  metrics: CampaignMetrics | void;
  token: string;

  actions: {
    openSnackbar: (type: string, message: string) => mixed,
  },
  t: any;
  theme: any;
}

const DEFAULT_STATE = {
  notifyAdvertiser: true,
};

type State = {
  notifyAdvertiser: boolean;
}

export class CompleteCampaignDialog extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = DEFAULT_STATE;
  }

  onCancel = () => {
    this.reset();
    this.props.onClose();
  };

  reset = () => {
    this.setState(DEFAULT_STATE);
  };

  onCompleteCampaign = async () => {
    const { campaign, token, onSuccess, t, actions } = this.props;
    const { notifyAdvertiser } = this.state;

    try {
      const completedCampaign = await CampaignAPI.completeCampaign(token, campaign.radio.callSign, campaign.reference, notifyAdvertiser);
      onSuccess(completedCampaign);
      this.reset();
    } catch (error) {
      actions.openSnackbar('error', t('campaigns:completeCampaignError'));
    }
  };

  onNotifyAdvertiserChange = (e: Event, value: boolean) => {
    this.setState({ notifyAdvertiser: value });
  };

  render() {
    const { t, theme, onClose, campaign, metrics } = this.props;

    const actions = [
      <RaisedButton
        onClick={this.onCancel}
        label={t('cancel')}
        key="cancel-button"
      />,
      <div key="right-action-buttons">
        <PrintCampaignButton
          campaign={campaign}
          metrics={metrics}
          label={t('printCampaign')}
        />
        <RaisedButton
          style={{ marginLeft: theme.metrics.smallMargin }}
          primary
          label={t('finish')}
          onClick={this.onCompleteCampaign}
        />
      </div>,
    ];

    const actionsContainerStyle = {
      padding: `${theme.metrics.margin}px ${theme.metrics.largeMargin}px`,
      backgroundColor: `${theme.colors.primaryBackground}`,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    };

    return (
      <Dialog
        title={t('commonCampaign:completeCampaign')}
        open={this.props.visible}
        onRequestClose={onClose}
        actions={actions}
        actionsContainerStyle={actionsContainerStyle}
        bodyStyle={{ padding: '16px 32px' }}
        titleStyle={{
          ...theme.fonts.style.secondary,
          color: theme.colors.tertiaryText,
          backgroundColor: theme.colors.primary,
        }}
        autoScrollBodyContent
      >
        <Text>
          {t('finalization.message', { campaignName: campaign.getName() })}
          &nbsp;
          {metrics && t('finalization.notifyAdvertiserMessage', { customerName: campaign.getAdvertiserName() })}
          {!metrics && t('finalization.campaignWithoutSpotMessage')}
        </Text>
        {metrics &&
          <Checkbox
            id={NOTIFY_ADVERTISER_CHECKBOX_ID}
            label={t('finalization.notifyClientCheckboxText')}
            name="notifyAdvertiser"
            onCheck={this.onNotifyAdvertiserChange}
            checked={this.state.notifyAdvertiser}
          />
          }
      </Dialog>
    );
  }
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({
      openSnackbar,
    }, dispatch),
  };
}

export default translate('campaigns', 'commonCampaign')(connect(null, mapDispatchToProps)(withTheme(CompleteCampaignDialog)));



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/components/CompleteCampaignDialog.js